import { Badge, Avatar, Typography, makeStyles } from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";

const useStyles = makeStyles((theme) => ({
  toggleButtonGroup: {},
  toggleButton: {
    width: 180,
    height: 38,
  },
  selected: {
    backgroundColor: "orange!important",
    color: "white!important",
  },
  circleItem: {
    width: 77,
    height: 77,
    borderRadius: 37,
    borderWidth: 1,
    borderColor: theme.orange,
  },
  circleItemsContainer: {
    display: "flex",
    width: 500,
    padding: 10,
    marginTop: 17,
    justifyContent: "space-around",
    alignItems: "center",
  },
  circleText: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.orange,
  },
  circleText_selected: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.white,
  },
  circleConditionBadge: {
    width: 44,
    height: 44,
    backgroundColor: theme.orange,
  },
  circleConditionBadgeText: { fontSize: 10, color: theme.white },
}));

const CircleToggleButtonItem = ({
  label,
  selected,
  onClick,
  imgUrl,
  conditions,
}) => {
  const classes = useStyles();

  return (
    <Badge
      overlap="circle"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      badgeContent={
        conditions[0] && conditions[0].value !== 0 ? (
          <Avatar className={classes.circleConditionBadge}>
            <Typography
              className={classes.circleConditionBadgeText}
              align="center"
            >
              {conditions[0].getMessage()}
            </Typography>
          </Avatar>
        ) : null
      }
    >
      <ToggleButton
        className={classes.circleItem}
        classes={{ selected: classes.selected }}
        onClick={onClick}
        selected={selected}
      >
        {imgUrl ? (
          <Typography
            className={
              selected ? classes.circleText_selected : classes.circleText
            }
          >
            {label}
          </Typography>
        ) : (
          <Typography
            className={
              selected ? classes.circleText_selected : classes.circleText
            }
          >
            {label}
          </Typography>
        )}
      </ToggleButton>
    </Badge>
  );
};

export default CircleToggleButtonItem;
